export const POST_VALIDATE_ACCESS_LINK_KEY = 'POST_VALIDATE_ACCESS_LINK_KEY';
